export function formatPercentage(value) {
    return (value * 100).toString().substring(0, 5) + "%"
}

export function formatPercentageToNumber(value) {
    return Number((value * 100).toString().substring(0, 5))
}

